import { Button, Col, DatePicker, Form, Input, Row, Select, Switch, Typography } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Dayjs } from 'dayjs';
import { productType } from 'interfaces/card-products';
import useGetCardAffinityGroups from '../../../hooks/CardAffinityGroup/useGetCardAffinityGroups';

export const ActiveCenter = styled.div`
  text-align: left !important;
`;

export const filterOption = (input: string, option?: { label: string; value: string }) =>
  (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

type FirstStepProps = {
  goToNext: () => void;
  setFirstStepData: (data: FirstStepFormInputs) => void;
  firstStepData: FirstStepFormInputs | null;
};

export type FirstStepFormInputs = {
  name: string,
  bin: string,
  range: string,
  productType: string,
  startDate: Dayjs,
  endDate: Dayjs,
  brand: string,
  active: boolean,
  lifeCycle: number,
  institutionId: string,
  card_affinity_group_id: string
};

const FirstStep: React.FC<FirstStepProps> = ({ goToNext, setFirstStepData, firstStepData }) => {
  const [form] = Form.useForm();
  const [active, setActive] = useState(true);
  const { affinityGroups, loading} = useGetCardAffinityGroups(0, 100, null);

  const onSubmit = (data: FirstStepFormInputs) => {
    data.active = active;
    setFirstStepData(data);
    goToNext();
  };

  return (
    <Form<FirstStepFormInputs>
      layout="vertical"
      onFinish={onSubmit}
      initialValues={firstStepData || undefined}
      form={form}
      style={{ width: 'max-content', maxWidth: '100%', margin: 'auto' }}
    >
      <Typography.Title level={2}>Datos principales</Typography.Title>
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item<FirstStepFormInputs>
            name="name"
            label={'Nombre'}
            rules={[{max: 40, required: true, message: 'Por favor, ingresa un nombre.' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item<FirstStepFormInputs>
            label="Fecha desde"
            name="startDate"
            rules={[{ required: true, message: 'Por favor, selecciona una fecha valida.' }]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item<FirstStepFormInputs>
            name="institutionId"
            label={'Id institucion'}
            rules={[{ required: true, message: 'Por favor, ingresa un Id Institucion valido.' }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<FirstStepFormInputs>
            name="bin"
            label={'Bin'}
            rules={[{ required: true, message: 'Por favor, selecciona un bin valido.' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item<FirstStepFormInputs>
            label="Fecha hasta"
            name="endDate"
            rules={[{ required: true, message: 'Por favor selecciona una fecha valida.' }]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item<FirstStepFormInputs>
            name="lifeCycle"
            label={'Ciclo de vida (años)'}
            rules={[{ required: true, message: 'Por favor, selecciona un número valido.' }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<FirstStepFormInputs>
            name="range"
            label={'Rango'}
            rules={[{ required: false, max: 2, message: 'Por favor, selecciona un rango valido.' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item<FirstStepFormInputs>
            name="brand"
            label={'Marca'}
            rules={[{ required: true, message: 'Por favor, selecciona una marca.' }]}
          >
            <Select
              placeholder="Seleccionar marca"
              options={[
                {
                  label: 'Visa',
                  value: 'VISA',
                },
                {
                  label: 'Mastercard',
                  value: 'MASTERCARD',
                },
              ]}
            />
          </Form.Item>
          <Form.Item<FirstStepFormInputs>
            label="Activo"
            name="active"
            initialValue={active}
            rules={[{required: false}]}
          >
            <ActiveCenter>
              <Switch onChange={() => setActive(!active)} defaultChecked/>
            </ActiveCenter>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<FirstStepFormInputs>
            name="productType"
            label={"Tipo de Producto"}
            rules={[{required:true, message: "Seleccione el tipo de producto"}]}>
                <Select
                  placeholder="Seleccione tipo de oriducto"
                  options={productType}
                />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<FirstStepFormInputs>
            label="Grupo de afinidad"
            name="card_affinity_group_id"
            rules={[{ required: true, message: 'Por favor selecciona una opcion.' }]}
          >
            <Select
              placeholder="Seleccionar"
              showSearch
              filterOption={filterOption}
              loading={loading}
              options={affinityGroups?.map((affg) => ({ label: affg.name, value: affg.id }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item style={{ textAlign: 'center' }}>
        <Button htmlType="submit" type="primary">
          Siguiente
        </Button>
      </Form.Item>
    </Form>
  );
};

export default FirstStep;
